import { render } from "./QuestionAdd.vue?vue&type=template&id=393498bd"
import script from "./QuestionAdd.vue?vue&type=script&lang=js"
export * from "./QuestionAdd.vue?vue&type=script&lang=js"

import "./QuestionAdd.vue?vue&type=style&index=0&id=393498bd&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__